import useStore from 'hooks/useStore';
import { SET_CURRENT_NOTIFY_DATA } from 'store/action';

const useNotificationStore = () => {
  const { state, setState, dispatch } = useStore();

  const { currentNotifyData } = state || {};

  const setCurrentNotifyData = (notifyData = null) =>
    setState({
      action: SET_CURRENT_NOTIFY_DATA,
      payload: notifyData,
    });

  return {
    state,
    setState,
    dispatch,
    ...state,
    currentNotifyData,
    setCurrentNotifyData,
  };
};

export default useNotificationStore;
